export const POINT_TYPE_COLUMN_TIP =
  "Which point pool this row belongs to, such as Standard Premium. This is not the transaction kind.";

export const POINT_TXN_COLUMN_TIP =
  "ACCRUAL: posted after an order’s cooling-off date. The Order column is filled in.\n\nADJUSTMENT: posted by hand in Management → Point Transactions. Order is usually empty.\n\nPosted rows cannot be edited. To correct a mistake, add another ADJUSTMENT (negative to reverse).";

export const POINT_POSTED_BY_COLUMN_TIP =
  "Who posted this row. SYSTEM is the nightly accrual job. A name is a manual ADJUSTMENT.";

export const POINT_ORDER_COLUMN_TIP =
  "Policy order for an ACCRUAL. A dash means this row is a manual ADJUSTMENT.";

export const POINT_ADJUSTMENT_PATH = "/management/pointTransaction";

function personLabel(person) {
  if (!person || typeof person !== "object") return "";
  return `${person.name || ""} ${person.staffId || ""}`.trim();
}

export function consultantLabelFromPointTransaction(row) {
  const fromUser = personLabel(row?.user);
  if (fromUser) return fromUser;

  const labels = (row?.snapshot?.consultantIds || [])
    .map(personLabel)
    .filter(Boolean);
  return labels.length ? labels.join(", ") : "-";
}

export function isSystemPostedBy(postedBy) {
  return !postedBy || postedBy === "SYSTEM";
}
